import { z } from 'zod';
import { cuid } from './primitives.js';

export const NOTIFICACAO_TIPOS = ['LOTE_PENDENTE', 'REVISAR_PRECO', 'ORCAMENTO_VENCENDO', 'RATEIO_SALVO', 'RATEIO_EXCLUIDO', 'LISTA_PUBLICADA', 'NOVA_VERSAO', 'PUBLICACAO_TERMINA_7D', 'PUBLICACAO_TERMINA_HOJE', 'PUBLICACAO_EM_VIGOR', 'LOTE_AFETA_PUBLICADOS', 'INTEGRACAO_FALHOU'] as const;
export type NotificacaoTipo = (typeof NOTIFICACAO_TIPOS)[number];

export interface NotificacaoResponse {
  id: string;
  tipo: NotificacaoTipo;
  titulo: string;
  texto: string;
  /** Rota do app (com query string quando ja filtrada). */
  link: string | null;
  lida: boolean;
  criadaEm: string;
}

/** GET /notificacoes: ultimas 50 (nao lidas primeiro nao: ordem cronologica desc) e o total de nao lidas. */
export interface NotificacoesResponse {
  naoLidas: number;
  itens: NotificacaoResponse[];
}

export const notificacaoIdParam = z.object({ id: cuid });

/** Retencao das notificacoes (dias). */
export const NOTIFICACOES_RETENCAO_DIAS = 90;
